export const getNodePath = (root: Node, target: Node): number[] => {
  const path: number[] = [];
  let currentNode: Node = target;

  while (currentNode !== root) {
    const parent = currentNode.parentNode;

    if (!parent) {
      return [];
    }

    const siblings = Array.from(parent.childNodes);
    const nodeToFind = currentNode;
    const indexInParent = siblings.findIndex((node) => node.isSameNode(nodeToFind));

    if (indexInParent === -1) {
      return [];
    }

    path.unshift(indexInParent);
    currentNode = parent;
  }

  return path;
};
